import { PortalAdapterApi } from "@vacancorp/portal.adapter.api";
import {
  fetchPlaceImagesByPlaceIdHash,
  FilterParams,
  getEvacuationDrill,
  getFacilityVacancyListByPlaceIdHashList,
  getPlaceListByLocation,
} from "../adapter.api";
import { ResponseGetEvacuationDrillMode } from "@/@types/evacuation-drill";
import { resolveFetchGenre } from "@/util/filter-genre.helper";

export class PlaceService {
  static async fetchPlaceListByLocation({
    lat,
    lng,
    radius,
    countryName,
    params,
    areaName,
    mapType,
    isOpendata,
    placeName,
  }: {
    lat: number;
    lng: number;
    radius: number; // meter
    countryName: string;
    params: FilterParams;
    areaName?: string;
    mapType?: string;
    isOpendata?: boolean;
    placeName?: string;
  }): Promise<PortalAdapterApi.ResponseGetPublicPlace[]> {
    const convertedAreaName: string | undefined =
      areaName === "Default" || areaName === "current-place" || areaName === "unknown" || !areaName
        ? undefined
        : areaName;

    const convertedGenre: string[] = await resolveFetchGenre({
      mapsMapType: params.mapsMapType,
      genre: params.genre,
      genreCategoryList: params.genreCategoryList,
      countryName,
    });
    const convertedParams = { ...params };
    convertedParams.genre = convertedGenre;
    console.log(`fetchPlaceListByLocation params`);
    console.log(convertedParams);
    return getPlaceListByLocation({
      lat,
      lng,
      radius,
      countryName,
      params: convertedParams,
      areaName: convertedAreaName,
      mapType,
      isOpendata,
      placeName,
    });
  }
  static fetchFacilityVacancyListByPlaceIdHashList(
    placeIdHashList: string[],
  ): Promise<PortalAdapterApi.ResponseGetMergedDisplayVacancy[]> {
    return getFacilityVacancyListByPlaceIdHashList(placeIdHashList);
  }

  static fetchEvacuationDrill(placeIdHashList: string[]): Promise<ResponseGetEvacuationDrillMode[] | undefined> {
    return getEvacuationDrill(placeIdHashList);
  }

  // 店舗の画像
  static getPlaceImagesByPlaceIdHash({
    placeIdHash,
    page,
    isOpendata,
  }: {
    placeIdHash: string;
    page: number;
    isOpendata: boolean;
  }) {
    return fetchPlaceImagesByPlaceIdHash({ placeIdHash, page, isOpendata });
  }
}
